import React, { lazy } from "react";

const Home = lazy(() => import("../pages/home/home.jsx"));
const Edm = lazy(() => import("../pages/edm/edm.js"));
const FocusTopic = lazy(() => import("../pages/focusTopic/focusTopic.js"));
const Partners = lazy(() => import("../pages/partners/partners.js"));
const AboutUs = lazy(() => import("../pages/aboutUs/aboutUs.js"));
const Review = lazy(() => import("../pages/review/review.js"));
const LiveCenter = lazy(() => import("../pages/liveCenter/liveCenter.jsx"));
const VideoDetail = lazy(() => import("../components/VideoDetail/VideoDetail.js"));
const NewsCenter = lazy(() => import("../pages/newsCenter/newsCenter.js"));
const NewsCenterDetail = lazy(() => import("../pages/newsCenter/detail/newsCenterDetail.js"))
const GSBN = lazy(() => import("@/pages/newsCenter/leadingEdges/GSBN.js"));
const CHUANSHIBAO = lazy(() => import("@/pages/newsCenter/leadingEdges/CHUANSHIBAO.js"))
const ChinaEasternAirlines = lazy(() => import("@/pages/newsCenter/leadingEdges/ChinaEasternAirlines.js"))
const SmartPort = lazy(() => import("@/pages/newsCenter/leadingEdges/SmartPort.js"))
const InnovationDriven = lazy(() => import("@/pages/newsCenter/leadingEdges/InnovationDriven.js"))
const BOCOM = lazy(() => import("@/pages/newsCenter/leadingEdges/BOCOM.js"))
const CPIC = lazy(() => import("@/pages/newsCenter/leadingEdges/CPIC.js"))
const Forum = lazy(() => import("@/pages/forum/forum.js"))
const Forum_2026 = lazy(() => import("@/pages/forum/2026/forum_2026.jsx"))
const Explore = lazy(() => import("@/pages/explore/explore.js"))
const CulturalCollection = lazy(() => import("@/pages/culturalCollection/culturalCollection.jsx"))
const AchievementCollection = lazy(() => import("@/pages/achievementCollection/achievementCollection.jsx"))
const Review_2024 = lazy(() => import("@/pages/review/2024/review_2024.jsx"))
const Review_2025 = lazy(() => import("@/pages/review/2025/review_2025.jsx"))
const IndustryAchievements = lazy(() => import("@/pages/industryAchievements/industryAchievements.jsx"))
const NBF365 = lazy(() => import("@/pages/nbf365/nbf365.jsx"))
const NBF365List = lazy(() => import("@/pages/nbf365/nbf365List/nbf365List.jsx"))

const routes = [
  {
    path: "/",
    element: <Home />,
    share: { title: '首页' },
  },
  {
    path: "/forum",
    element: <Forum_2026 />,
    share: { title: '2026论坛', desc: '论坛议程、同期活动、演讲嘉宾' },
  },
  {
    path: "/forum/2025",
    element: <Forum />,
    share: { title: '2025论坛', desc: '论坛议程、演讲嘉宾、同期活动' },
  },
  {
    path: "/explore",
    element: <Explore />,
    share: { title: '探索发现' },
  },
  {
    path: "/cultural-collection",
    element: <CulturalCollection />,
    share: { title: '文化集锦' },
  },
  {
    path: "/achievement-collection",
    element: <AchievementCollection />,
    share: { title: '成果集锦' },
  },
  {
    path: "/edm",
    element: <Edm />,
    share: { title: '留言咨询' },
  },
  {
    path: "/focus-topic",
    element: <FocusTopic />,
    share: { title: '高端访谈' },
  },
  {
    path: "/focus-topic/:id",
    element: <VideoDetail />,
  },
  {
    path: "/partners",
    element: <Partners />,
    share: { title: '战略合作', desc: '战略合作单位、合作单位、合作媒体' },
  },
  {
    path: "/about-us",
    element: <AboutUs />,
    share: { title: '关于我们', desc: '论坛宗旨、组织架构、论坛顾问' },
  },
  {
    path: "/review/:id",
    element: <Review />,
    share: { title: '往届回顾' },
  },
  {
    path: "/review/:id/:id",
    element: <VideoDetail />,
  },
  {
    path: "/review/2025",
    element: <Review_2025 />,
    share: { title: '2025回顾' },
  },
  {
    path: "/review/2024",
    element: <Review_2024 />,
    share: { title: '2024回顾' },
  },
  {
    path: "/live-center",
    element: <LiveCenter />,
    share: { title: '直播中心', desc: '视频直播、图文直播' },
  },
  {
    path: "/live-center/:id",
    element: <VideoDetail />,
  },
  {
    path: "/news-center",
    element: <NewsCenter />,
    share: { title: '新闻中心', desc: '新闻动态、行业动态、行业发布' },
  },
  {
    path: "/news-center/:id",
    element: <NewsCenterDetail />,
  },
  {
    path: "/news-center/leading-edges/GSBN",
    element: <GSBN />,
    share: { title: 'GSBN - 案例展示' },
  },
  {
    path: "/news-center/leading-edges/CHUANSHIBAO",
    element: <CHUANSHIBAO />,
    share: { title: '船视宝 - 案例展示' },
  },
  {
    path: "/news-center/leading-edges/China-Eastern-Airlines",
    element: <ChinaEasternAirlines />,
    share: { title: '中国东方航空 - 案例展示' },
  },
  {
    path: "/news-center/leading-edges/Smart-Port",
    element: <SmartPort />,
    share: { title: '智慧港口 - 案例展示' },
  },
  {
    path: "/news-center/leading-edges/Innovation-Driven",
    element: <InnovationDriven />,
    share: { title: '创新驱动 - 案例展示' },
  },
  {
    path: "/industry-achievements/typical-cases/CPIC",
    element: <CPIC />,
    share: { title: '太平洋保险 - 案例展示' },
  },
  {
    path: "/industry-achievements/typical-cases/BOCOM",
    element: <BOCOM />,
    share: { title: '交通银行 - 案例展示' },
  },
  {
    path: "/news-center/leading-edges/BOCOM",
    element: <BOCOM />,
    share: { title: '交通银行 - 案例展示' },
  },
  {
    path: "/high-lights/:id/:id",
    element: <VideoDetail />,
  },
  {
    path: '/industry-Achievements',
    element: <IndustryAchievements />,
    share: { title: '行业成果' },
  },
  {
    path: '/nbf365',
    element: <NBF365 />,
    share: { title: 'NBF365', desc: '行业资讯、政策发布、重点服务平台' },
  },
  {
    path: '/nbf365/information',
    element: <NBF365List />,
    share: { title: '行业资讯 - NBF365' },
  },
  {
    path: '/nbf365/information/:id',
    element: <NewsCenterDetail />,
  },
  {
    path: '/nbf365/policy',
    element: <NBF365List />,
    share: { title: '政策发布 - NBF365' },
  },
  {
    path: '/nbf365/policy/:id',
    element: <NewsCenterDetail />,
  }
]

export default routes
